<template>
	<div>
		<v-row>
			<v-col cols="12">
				<div class="line-title mt-1">
					<span class="text"> ثبت سفارش خرید اقساطی</span>
					<span class="line"></span>
				</div>
			</v-col>
			<!-- Image Section -->
			<v-col cols="12" md="12" class="d-flex justify-center">
				<v-img src="/new-order.jpg" height="100%" max-width="500" class="rounded-lg" contain></v-img>
			</v-col>

			<!-- Form Section -->
			 </v-row>
			 <v-row justify="center">
			<v-col cols="12" sm="12" md="10" xl="6">
				<p class="text-justify grey--text fs-h5" style="">
					کاربر گرامی شما می توانید با پر کردن فرم زیر، خرید کالای مورد نظر خود را به صورت قسطی به ما بسپارید و اقساط آن را
					به ما پرداخت کنید.
				</p>
				<v-slide-x-transition :hide-on-leave="true">
					<div v-if="orderSubmitted">
						<v-alert type="success" class="mb-2" outlined>
							{{ message }}
						</v-alert>
						<div class="text-center">
							<v-btn outlined small color="primary" @click="() => { message = ''; orderSubmitted = false }">
								ثبت سفاش خرید جدید
							</v-btn>
						</div>
					</div>
				</v-slide-x-transition>
				<v-slide-x-transition :hide-on-leave="true">
					<div v-if="!orderSubmitted" class="py-3 px-6">
						<v-form ref="form" lazy-validation class="" @submit.prevent="submitOrder">
							<v-text-field label="نام و نام خانوادگی" outlined dense required v-model="localData.name" :rules="[() => !!localData.name || 'نام و نام خانوادگی را وارد کنید']" class="text-right"></v-text-field>

							<v-text-field label="کد ملی" max-length="10" outlined dense required v-model="localData.nationalCode" :rules="[() => !!localData.nationalCode || 'کد ملی را وارد کنید', (val) => checkCodeMeli(val) || 'کد ملی وارد شده معتبر نمی باشد']" class="text-left"></v-text-field>

							<v-text-field label="شماره تماس" outlined dense required class="text-left" v-model="localData.phone" :rules="[() => !!localData.phone || 'شماره تماس را وارد کنید']"></v-text-field>

							<v-text-field label="نام کالای مورد نظر" outlined dense class="text-right" v-model="localData.productName" :rules="[() => !!localData.productName || 'نام محصول را وارد کنید']"></v-text-field>

							<v-textarea label="توضیحات و لینک خرید" outlined dense rows="3" v-model="localData.description" class="text-right"></v-textarea>

							<v-btn color="primary" class="mt-4" block :loading="submitLoading" type="submit">ثبت درخواست</v-btn>

							<v-alert class="mt-3" type="warning" outlined dense v-if="message">
								{{ message }}
							</v-alert>

						</v-form>
					</div>
				</v-slide-x-transition>
			</v-col>
		</v-row>

	</div>
</template>

<script>
	import { get } from 'vuex-pathify'
	import api from '@/util/app-api'
	import router from '@/router'

	export default {
		name: 'NewOrder',
		components: {
			'loan-calculator': () => import('@/components/LoanCalculator'),
		},
		props: {
			customerCode: { type: Number },
		},
		data: () => ({
			errorMessage: '',
			localData: {},
			submitLoading: false,
			message: '',
			orderSubmitted: false
		}),
		mounted() {
		},
		methods: {
			submitOrder() {
				if (!this.$refs.form.validate()) { return }
				this.submitLoading = true
				this.message = ''
				api.post('CustomerOrder/create', this.localData, { authHeader: false })
					.then(response => {
						this.message = 'درخواست شما با موفقیت ثبت شد و در اسرع وقت توسط کارشناسان مورد بررسی قرار خواهد گرفت'
						this.localData = {}
						this.orderSubmitted = true
					})
					.catch(err => {
						this.message = err.message || 'خطا در ارسال اطلاعات به سرور'
					})
					.finally(() => {
						this.submitLoading = false
					})
			},
			checkCodeMeli(code) {
				var L = code?.length  || 0

				if (L < 8 || parseInt(code, 10) == 0) return false
				code = ('0000' + code).substr(L + 4 - 10)
				if (parseInt(code.substr(3, 6), 10) == 0) return false
				var c = parseInt(code.substr(9, 1), 10)
				var s = 0
				for (var i = 0; i < 9; i++)
					s += parseInt(code.substr(i, 1), 10) * (10 - i)
				s = s % 11
				return (s < 2 && c == s) || (s >= 2 && c == (11 - s))
			},
		},
	}
</script>

<style lang="scss"></style>